import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { onboardingEmailChangeBackend } from './onboarding-email-change.backend';
import { onboardingEmailChangeReducer } from './onboarding-email-change.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'onboardingEmailChange',
      onboardingEmailChangeReducer,
    ),
    BackendModule.forFeature(
      'onboardingEmailChange',
      onboardingEmailChangeBackend,
    ),
  ],
})
export class DatastoreOnboardingEmailChangeModule {}
